// Ported verbatim from the LeadMailer Design System (components/forms/Radio.jsx).
import React from 'react'

export interface RadioProps {
  checked?: boolean
  onChange?: (checked: boolean) => void
  label?: React.ReactNode
  name?: string
  disabled?: boolean
  style?: React.CSSProperties
}

export function Radio({ checked, onChange, label, disabled, style }: RadioProps) {
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        fontSize: 'var(--text-base)',
        color: 'var(--text-primary)',
        minHeight: 24,
        ...style,
      }}
      onClick={() => !disabled && onChange && onChange(true)}
    >
      <span
        style={{
          width: 16,
          height: 16,
          flex: 'none',
          borderRadius: '50%',
          border: `1px solid ${checked ? 'var(--accent)' : 'var(--border-strong)'}`,
          background: 'var(--surface-card)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'border-color var(--dur-fast) var(--ease-out)',
        }}
      >
        {checked && (
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--accent)' }} />
        )}
      </span>
      {label && <span>{label}</span>}
    </label>
  )
}
